import 'core-js/features/url-search-params';
import React from 'react';
import ReactDOM from 'react-dom';

// https://tigertext.atlassian.net/browse/TMG-830
// @ts-expect-error
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
